// extracted by mini-css-extract-plugin
module.exports = {"seriesLinkWrapper":"SeriesLink_seriesLinkWrapper__Mc_08"};